import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@zvoove-market/shared';
import { ADMIN_ROLE, BUSINESS_EXECUTIVE_ROLE } from '../auth/roles';

export const customerIsAdminOrKeyUserGuard = (): CanActivateFn => (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permittedRoles = [ADMIN_ROLE, BUSINESS_EXECUTIVE_ROLE];

  return (
    auth.$context().mandant?.roles.some((role) => permittedRoles.includes(role)) ||
    !!auth.$context().customer?.keyUserId ||
    router.parseUrl('/page-not-found')
  );
};
